import Combobox from '@/components/ui/combo-box'
import { Controller } from 'react-hook-form'
import { cn } from '@/lib/utils'

const Selector = ({ field, value, errors, onChange, setPixelId, pixels, disabled }) => {
    const options = pixels.map((pixel) => ({
        value: pixel.id,
        label: pixel.id + ' - ' + pixel.name,
    }))

    return (
        <Combobox
            {...field}
            options={options}
            value={value}
            onChange={onChange}
            disabled={disabled}
            className={cn(errors.pixel && 'tw:!border-destructive')}
            popoverStyle={{ zIndex: 1000 }}
        />
    )
}

const PixelSelector = ({ control, value, errors, onChange, setPixelId, pixels, disabled }) => {
    return (
        <>
            <Controller
                name="pixel"
                control={control}
                rules={{ required: 'Please select a Pixel' }}
                render={({ field }) => (
                    <Selector
                        field={field}
                        errors={errors}
                        value={value}
                        onChange={onChange}
                        setPixelId={setPixelId}
                        pixels={pixels}
                        disabled={disabled}
                    />
                )}
            />

            {errors.pixel && <p className="tw:mt-1.5 tw:text-sm tw:text-error">{errors.pixel.message}</p>}
        </>
    )
}

export default PixelSelector
